<template>
    <div>
        <template v-if="window_width >= 992">

            <!-- Search - Questions -->
            <b-dropdown-item :class="!user_permissions.includes('read-questions') ? 'cursor-not-allowed' : ''"
                             v-b-tooltip.hover.right="{ title: !user_permissions.includes('read-questions') ? $t('permission.permission_denied', { permission: 'read-questions' }) : '', customClass: 'tooltip-dark' }"
                             :disabled="!user_permissions.includes('read-questions')" :to="search_questions_route" active-class="active"><font-awesome-icon :icon="'inbox'" /> {{ $t('page.questions') }}</b-dropdown-item>
            <!-- Search - Answers --> 
            <b-dropdown-item :class="!user_permissions.includes('read-answers') ? 'cursor-not-allowed' : ''"
                             v-b-tooltip.hover.right="{ title: !user_permissions.includes('read-answers') ? $t('permission.permission_denied', { permission: 'read-answers' }) : '', customClass: 'tooltip-dark' }"
                             :disabled="!user_permissions.includes('read-answers')" :to="search_answers_route" active-class="active"><font-awesome-icon :icon="'comments'" /> {{ $t('page.answers') }}</b-dropdown-item>
            <!-- Search - Customers -->
            <b-dropdown-item :class="!user_permissions.includes('read-customers') ? 'cursor-not-allowed' : ''"
                             v-b-tooltip.hover.right="{ title: !user_permissions.includes('read-customers') ? $t('permission.permission_denied', { permission: 'read-customers' }) : '', customClass: 'tooltip-dark' }"
                             :disabled="!user_permissions.includes('read-customers')" :to="search_customers_route" active-class="active"><font-awesome-icon :icon="'users'" /> {{ $t('reports.customers') }}</b-dropdown-item>
            <!-- Search - Tickets -->
            <b-dropdown-item :class="!user_permissions.includes('read-tickets') ? 'cursor-not-allowed' : ''"
                             v-b-tooltip.hover.right="{ title: !user_permissions.includes('read-tickets') ? $t('permission.permission_denied', { permission: 'read-tickets' }) : '', customClass: 'tooltip-dark' }"
                             :disabled="!user_permissions.includes('read-tickets')" :to="search_tickets_route" active-class="active"><font-awesome-icon :icon="'ticket-alt'" /> {{ $t('page.tickets') }}</b-dropdown-item>
        </template>

        <template v-else>
            <!-- Search - Questions -->
            <b-link :class="['plus-header-accordion-links',{ 'cursor-not-allowed': !user_permissions.includes('read-questions') }]"
                    v-b-tooltip.hover.right="{ title: !user_permissions.includes('read-questions') ? $t('permission.permission_denied', { permission: 'read-questions' }) : '', customClass: 'tooltip-dark' }"
                    :disabled="!user_permissions.includes('read-questions')" :to="search_questions_route" active-class="active"><font-awesome-icon :icon="'inbox'" /> {{ $t('page.questions') }}</b-link>
            <!-- Search - Answers --> 
            <b-link :class="['plus-header-accordion-links',{ 'cursor-not-allowed': !user_permissions.includes('read-answers') }]"
                    v-b-tooltip.hover.right="{ title: !user_permissions.includes('read-answers') ? $t('permission.permission_denied', { permission: 'read-answers' }) : '', customClass: 'tooltip-dark' }"
                    :disabled="!user_permissions.includes('read-answers')" :to="search_answers_route" active-class="active"><font-awesome-icon :icon="'comments'" /> {{ $t('page.answers') }}</b-link>
            <!-- Search - Customers -->
            <b-link :class="['plus-header-accordion-links',{ 'cursor-not-allowed': !user_permissions.includes('read-customers') }]"
                    v-b-tooltip.hover.right="{ title: !user_permissions.includes('read-customers') ? $t('permission.permission_denied', { permission: 'read-customers' }) : '', customClass: 'tooltip-dark' }"
                    :disabled="!user_permissions.includes('read-customers')" :to="search_customers_route" active-class="active"><font-awesome-icon :icon="'users'" /> {{ $t('reports.customers') }}</b-link>
            <!-- Search - Tickets -->
            <b-link :class="['plus-header-accordion-links',{ 'cursor-not-allowed': !user_permissions.includes('read-tickets') }]"
                    v-b-tooltip.hover.right="{ title: !user_permissions.includes('read-tickets') ? $t('permission.permission_denied', { permission: 'read-tickets' }) : '', customClass: 'tooltip-dark' }"
                    :disabled="!user_permissions.includes('read-tickets')" :to="search_tickets_route" active-class="active"><font-awesome-icon :icon="'ticket-alt'" /> {{ $t('page.tickets') }}</b-link>

        </template>
    </div>

</template>
<script>

import {mapGetters} from "vuex";

export default {
    mounted() {
        this.$nextTick(() => {
              window.addEventListener('resize', this.onResize);
        })
    },

    beforeDestroy() { 
            window.removeEventListener('resize', this.onResize); 
    },

    data: function () {
        return {
            window_width: window.innerWidth,
            search_questions_route: '/search/questions',
            search_answers_route: '/search/answers',
            search_customers_route: '/search/customers',
            search_tickets_route: '/search/tickets',
        }
    },

    methods: {
        onResize() {
            this.window_width = window.innerWidth;
        },  
    },
  computed: {
    ...mapGetters({
      user_permissions: 'User/getUserPermissions',
    }),
    permissionsReady() {
      return Array.isArray(this.user_permissions) && this.user_permissions.length > 0;
    }
  }

}

</script>